import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'
import VueToastr from "vue-toastr";
import moment from 'moment'
import Select2 from 'v-select2-component';
import vSelect from 'vue-select'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.prototype.moment = moment

Vue.use(VueToastr, {
    timeout: 50000,
    /* OverWrite Plugin Options if you need */
});

Vue.use(VueSweetalert2);
Vue.component('v-select', vSelect)
Vue.component('Select2', Select2);
Vue.use(VueFeather)
Vue.use(flatPickr)
Vue.use(VueApexCharts)
Vue.use(VueRouter)
Vue.use(vco)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
    // Ensure tests fail when Vue emits an error.
    Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.component('apexchart', VueApexCharts)

// Uncomment this if you are having api served through other url or do not want to use fake backend
Vue.prototype.$http = require('axios')

Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_RUTA_API;

const app = new Vue({
    router,
    store,
    mounted() {
        // You are able to access plugin from everywhere via this.$toastr
        this.$toastr.defaultPosition = "toast-top-right";
        // Send message to browser screen
        //    this.$toastr.s(
        //      "This Message From Toastr Plugin\n You can access this plugin : <font color='yellow'>this.$toastr</font>"
        //    );
    },
    render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
    // Attach the app to the window, which can be useful
    // for manually setting state in Cypress commands
    // such as `cy.logIn()`.
    window.__app__ = app
}